// import { getToken } from "firebase/messaging";
import { motion } from "framer-motion";
import 'mapbox-gl/dist/mapbox-gl.css';
import { useEffect } from "react";
import {
    RouterProvider,
    createBrowserRouter
} from "react-router-dom";
import { RecoilRoot } from "recoil";
import './App.css';
import Cart from "./app/routes/Cart";
import Checkout from "./app/routes/Checkout";
import ConfirmDelivery from "./app/routes/ConfirmDelivery";
import GettingStarted from "./app/routes/GettingStarted";
import HomeScreen from "./app/routes/HomeScreen";
import LoginInit from "./app/routes/LogInInit";
import Notifications from "./app/routes/Notifications";
import Order from "./app/routes/Order";
import ProductView from "./app/routes/ProductView";
import SplashScreen from "./app/routes/Splashscreen";
import SuccessCheckout from "./app/routes/Success";
import UpdateCart from "./app/routes/UpdateCart";
import UserInfo from "./app/routes/UserNames";
import VerifyNumber from "./app/routes/VerifyNumber";
import "./index.css";

import { useState } from "react";

function NotificationSub({ children }) {

    useEffect(() => {

        // getToken(msg, {
        //     vapidKey: "BKCVmjhpheit2x1MZlQxreqCsmkOcKpRin4CnTISJNlK_2OCe0pkA2Ir8IQH-tf76AvZb80NZWtd13zEH5Koeu8"
        // }).then(token => {
    
        //     setDoc(doc(db, `notifications/xVvJ0cgMw4Y1xItNteiSF15fn5O2`), {
        //         token
        //     })
    
        // }).catch(console.log)

    }, [])

    return (
        <motion.div 
            initial={{ y: 20, opacity: 0, scale: 0.7 }}
            animate={{ y: 0, opacity: 1, scale: 1}}
            style={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <p>Subscribed</p>
        </motion.div>
    )
}

function FollowUp() {
    return (
        <motion.div 
            initial={{ y: 20, opacity: 0, scale: 0.7 }}
            animate={{ y: 0, opacity: 1, scale: 1}}
            style={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <h1>Oops, Something wrong happened, please reload page</h1>
            <br/>
            <button onClick={() => window.location.href = "/"}>
                Reload
            </button>
        </motion.div>
    )
}

const router = createBrowserRouter([
    {
        path: "/",
        element: <SplashScreen />, 
        errorElement: <FollowUp />
    },
    {
        path: "/getting-started",
        element: <GettingStarted />, 
        errorElement: <FollowUp />
    },
    {
        path: "/login",
        element: <LoginInit />, 
        errorElement: <FollowUp />
    },
    {
        path: "/verify-number",
        element: <VerifyNumber />, 
    },
    {
        path: "/auth-1/:token",
        element: <HomeScreen />, 
    },
    {
        path: "/auth-1/:token/configuration",
        element: <UserInfo />, 
    },
    {
        path: "/auth-1/:token/notifications",
        element: <Notifications />, 
        errorElement: <FollowUp />
    },
    {
        path: "/auth-1/:token/notifications/order",
        element: <Order />, 
    },
    {
        path: "/auth-1/:token/cart",
        element: <Cart />, 
        errorElement: <FollowUp />
    },
    {
        path: "/auth-1/:token/cart/checkout",
        element: <Checkout />, 
        errorElement: <FollowUp />
    },
    {
        path: "/auth-1/:token/cart/checkout/delivery/confirm",
        element: <ConfirmDelivery />, 
    },
    {
        path: "/auth-1/:token/cart/checkout/success",
        element: <SuccessCheckout />, 
    },
    {
        path: "/auth-1/:token/product",
        element: <ProductView />, 
        errorElement: <FollowUp />
    },
    {
        path: "/auth-1/:token/product/update",
        element: <UpdateCart />, 
    },
    {
        path: "/admin",
        element: <NotificationSub />, 
    }
]);


function App() {

    const [hidePromo, setHidePromo] = useState(true)
    const [showButton, setShowButton] = useState(false)
    const auth = {
        currentUser: JSON.parse(localStorage.getItem("user"))
    }

    useEffect(() => {

        const html = document.getElementsByTagName("html")
        const theme = localStorage.getItem("theme")
        const curTheme = (theme === "dark") ? "dark" : "light"

        if(window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(curTheme)
        }
        for(const doc of html) {
            doc.setAttribute("theme", curTheme)
            localStorage.setItem("theme", curTheme)
        }

        setTimeout(() => setShowButton(true), 5000)

    }, [])

    //setup notifications
    useEffect(() => {

        if(auth.currentUser) {
            // getToken(msg, {
            //     vapidKey: "BKCVmjhpheit2x1MZlQxreqCsmkOcKpRin4CnTISJNlK_2OCe0pkA2Ir8IQH-tf76AvZb80NZWtd13zEH5Koeu8"
            // }).then(token => {
    
            //     // console.log("user token: " + token)
            //     setDoc(doc(db, `notifications/${auth?.currentUser?.uid}`), {
            //         token
            //     })
    
            // }).catch(console.log)

        }

    }, [])

    useEffect(() => {

        // onMessage(msg, (payload) => {
        //     // console.log('Message received. ', payload);
        //     window.alert(payload.notification.body)
        //     // ...
        // });

    }, [])
 

    return <RecoilRoot>
        <RouterProvider router={router}
            fallbackElement={() => (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'var(--text)',
                    padding: 50
                }}>
                    <p>Something wrong happened, please reload page</p>
                </div>
            )}
        />
        {/* <motion.div id="promo-wrapper"
            animate={{
                opacity: hidePromo ? 0 : 1,
                y: hidePromo ? "100vh" : 0 
            }}
            style={{ zIndex: 20000000 }}
        >
            <div id="promo-container">
                <img src={promo1} 
                    alt="promo"
                />
                {showButton && <button onClick={() => setHidePromo(true)} id="promo-close">
                    <p>Continue To Shop</p>
                </button>}
            </div>
        </motion.div> */}
    </RecoilRoot>
}

export default App;
